import React, { useEffect } from 'react';
import { sanitizeInput } from '../../../_helper/inputSanitizer';
import { validateEmail } from '../../../_helper/validation';
import { SetValidMail } from '../../../model/form/MailInput';

type MailInputProps = {
    emailValidation: boolean;
    label: string;
    labelConfirm?: string;
    emailValue: string;
    emailConfirmValue: string;
    setEmail: ({ value, confirmValue, valid }: SetValidMail) => void;
};
export const MailInput = ({
    emailValidation,
    label,
    emailValue,
    emailConfirmValue,
    labelConfirm,
    setEmail,
}: MailInputProps) => {
    const [formErrors, setFormErrors] = React.useState<{ email: string; emailConfirm: string }>({
        email: '',
        emailConfirm: '',
    });
    const [firstMail, setFirstMail] = React.useState('');
    const [mailConfirm, setMailConfirm] = React.useState('');
    const [equalEmail, setEqualEmail] = React.useState(false);
    const [isInit, setIsInit] = React.useState(false);

    if (!isInit) {
        if (emailValue !== firstMail) {
            setFirstMail(emailValue);
        }
        if (emailConfirmValue !== mailConfirm) {
            setMailConfirm(emailConfirmValue);
        }

        setIsInit(true);
    }

    useEffect(() => {
        const isMailConfirmed = () => {
            return firstMail === mailConfirm;
        };

        if (firstMail && mailConfirm) {
            const mailsEqual = isMailConfirmed();

            if (mailsEqual !== equalEmail || (!mailsEqual && formErrors['emailConfirm'] === '')) {
                setEqualEmail(mailsEqual);
                if (!mailsEqual) {
                    formErrors['emailConfirm'] =
                        'Die E-Mail Adressen stimmen nicht überein. Bitte überprüfen Sie Ihre Eingabe und versuchen es nochmal.';
                    setFormErrors({ ...formErrors });
                }
            }

            setEmail({ value: firstMail, confirmValue: mailConfirm, valid: mailsEqual });
        }
    }, [firstMail, mailConfirm, equalEmail, formErrors, setEmail]);

    const handleChange = (e: React.ChangeEvent) => {
        if (e.target instanceof HTMLInputElement) {
            let errors = { ...formErrors };
            let valid = true;
            if (e.target.name === 'email' || e.target.name === 'emailConfirm') {
                const name = e.target.name;
                if (e.target.value === '') {
                    valid = false;
                    errors[name] =
                        'Bitte geben Sie Ihre E-Mail Adresse an, damit wir Sie über Ihre Anliegen auf dem Laufenden halten können.';
                } else if (validateEmail(sanitizeInput(e.target.value) as string)) {
                    errors[name] = '';
                } else {
                    valid = false;
                    errors[name] =
                        'Bitte geben Sie Ihre E-Mail Adresse an, damit wir Sie über Ihre Anliegen auf dem Laufenden halten können.';
                }

                setFormErrors({ ...errors });
                setEmail({ value: firstMail, confirmValue: mailConfirm, valid: valid });
            }
        }
    };

    return (
        <>
            <div className="container">
                <div className="input-container mail">
                    <label htmlFor="email">{label}</label>
                    <input
                        id="email"
                        type="email"
                        className={(formErrors['email'].length > 0 ? 'error' : '') + ' input'}
                        name="email"
                        autoComplete="email"
                        onBlur={(event) => {
                            handleChange(event);
                        }}
                        onChange={(e) => {
                            setFirstMail(sanitizeInput(e.target.value) as string);
                        }}
                        value={firstMail}
                    />
                    {formErrors['email'] && <div className="error text-red">{formErrors['email']}</div>}
                </div>
            </div>
            {emailValidation && (
                <div className="container">
                    <div className="input-container mail">
                        <label htmlFor="emailConfirm">{labelConfirm}</label>
                        <input
                            id="emailConfirm"
                            type="email"
                            className={formErrors['emailConfirm'].length > 0 ? 'error' : ''}
                            name="emailConfirm"
                            autoComplete="email"
                            onBlur={(event) => {
                                handleChange(event);
                            }}
                            onChange={(e) => {
                                setMailConfirm(sanitizeInput(e.target.value).toString());
                            }}
                            value={mailConfirm}
                        />
                        {formErrors['emailConfirm'] && (
                            <div className="error text-red">{formErrors['emailConfirm']}</div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};
